export default __webpack_public_path__ + "static/media/msa-trusted-choice-footer-logo.906f4651.svg";